type Email = 'privacy' | 'security' | 'careers'

const EMAILS: Record<Email, string> = {
  security: 'security@schoolhouse.world',
  privacy: 'privacy@schoolhouse.world',
  careers: 'careers@schoolhouse.world',
}

export function get(type: Email, options: { as: 'text' | 'link' } = { as: 'link' }): string {
  return `${options.as === 'link' ? 'mailto:' : ''}${EMAILS[type]}`
}
